// ReporteRutinas.js
import React, { useState } from 'react';
import api from './api'; // Tu instancia de Axios

const ReporteRutinas = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const descargarCSV = async () => {
    try {
      const response = await api.get('/reportes/reporte_rutinas_csv', {
        params: {
          start_date: startDate,
          end_date: endDate
        },
        responseType: 'blob', // 👈 Necesario para archivos binarios
      });

      // Crear URL de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'reporte_rutinas.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar el CSV:', error);
    }
  };

  return (
    <div>
      <h2>Exportar Reporte de Rutinas</h2>
      <label>
        Fecha inicio:
        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
      </label>
      <label>
        Fecha fin:
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
      </label>
      <button onClick={descargarCSV}>Descargar CSV</button>
    </div>
  );
};

export default ReporteRutinas;
